<script lang="ts">
  import Button from "$lib/components/ui/button/button.svelte";
  import { TriangleAlert } from "lucide-svelte";
  import { user } from "$src/infrastructure/accounts/authStore";
  import * as Tooltip from "$lib/components/ui/tooltip/index.js";
  import * as DropdownMenu from "$lib/components/ui/dropdown-menu";
  import { onMount } from "svelte";
  import * as jsonpatch from "fast-json-patch";
  import lineItems from "$src/domain/projects/items/FakeLineItems";
  import { slide } from "svelte/transition";
  import { connectedUsers } from "$src/application/realtime/connectedUserStore";
  import type { ConnectedUser } from "$src/domain/realtime/ConnectedUser";
  import { getUserInitials } from "$src/domain/users/UserSummary";
  import { hubStore } from "$src/application/realtime/hubStore";
  import { HubService } from "$src/application/realtime/HubService";
  import { get } from "svelte/store";
  // import { time } from "console";

  // export let users = [
  //   { initials: "CV", id: 3, fullname: "Chritophe Vandalem" },
  //   { initials: "PI", id: 2, fullname: "Pierre Ioannatos" },
  //   { initials: "SL", id: 1, fullname: "Steve Lanuit" },
  // ];

  onMount(() => {
    // var original = lineItems;
    // var draft = JSON.parse(JSON.stringify(lineItems));
    // draft[12].product =  draft[11].product;
    // draft = draft.slice(0, 20);
    // draft[1].quantity = 180;
    // // console.time('executionTime');
    // var patch = jsonpatch.compare(original, draft);
    // console.log(JSON.stringify(patch));
    // // console.timeEnd('executionTime');
  });

  const maxVisibleUsers: number = 2;

  function getUsersWithoutMe(users: ConnectedUser[]) {
    var me = $hubStore?.getConnection().connectionId;

    return users.filter((u) => u.connectionId != me);
  }

  function getDisplayedUsers(users: ConnectedUser[]) {
    
    var usersWithoutMe = getUsersWithoutMe(users);

    return usersWithoutMe.length > maxVisibleUsers
      ? usersWithoutMe.slice(0, maxVisibleUsers - 1)
      : usersWithoutMe;
  }

  function getExtraUsersCount(users: ConnectedUser[]) {
    var usersWithoutMe = getUsersWithoutMe(users);

    return usersWithoutMe.length > maxVisibleUsers
      ? usersWithoutMe.length - maxVisibleUsers + 1
      : 0;
  }
</script>

{#if $hubStore}
  <div class=" md-max-w-56">
    <DropdownMenu.Root>
      <DropdownMenu.Trigger class="flex gap-1 items-center justify-end text-xs">
        {#if getUsersWithoutMe($connectedUsers).length > 0}
          <div class="hidden md:block text-xs font-bold text-yellow-600">
            <TriangleAlert size="20" />
          </div>
        {/if}

        {#each getDisplayedUsers($connectedUsers) as user}
          <Tooltip.Root>
            <Tooltip.Trigger asChild let:builder>
              <Button
                builders={[builder]}
                variant="user"
                class="border-green-500 shadow-md z-30"
              >
                {getUserInitials(user)}
              </Button>
            </Tooltip.Trigger>
            <Tooltip.Content>
              <p>{user.firstname} {user.lastname}</p>
            </Tooltip.Content>
          </Tooltip.Root>
        {/each}
        {#if getExtraUsersCount($connectedUsers) > 0}
          <div class="relative">
            <Button
              variant="user"
              class="  relative border-red-500 shadow-md z-30"
            >
              +{getExtraUsersCount($connectedUsers)}
            </Button>
            <div
              class="absolute top-0 left-0 bg-secondary rounded-full h-9 w-9 transform translate-x-2 border-2 border-primary/50"
            ></div>
          </div>
        {/if}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Group>
          <DropdownMenu.Label>Egalement sur ce projet</DropdownMenu.Label>
          <DropdownMenu.Separator />
          {#each getUsersWithoutMe($connectedUsers) as user}
            <DropdownMenu.Item
              >{user.firstname}
              {user.lastname}
              {user.action.toString()}
              {user.location}
            </DropdownMenu.Item>
          {/each}
        </DropdownMenu.Group>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  </div>
{/if}
